import { render, staticRenderFns } from "./PAMM.vue?vue&type=template&id=37928707"
import script from "./PAMM.vue?vue&type=script&lang=js"
export * from "./PAMM.vue?vue&type=script&lang=js"
import style0 from "./PAMM.vue?vue&type=style&index=0&id=37928707&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports